import styled from 'styled-components';

export const RemoveVehicleFinanceCompanyContainer = styled.div.attrs({
  id: 'RemoveVehicleFinanceCompanyContainer',
})`
  margin-top: 20px;
`;
export const RemoveVehicleFinanceCompanyField = styled.form.attrs({})`
  min-width: 200px;
`;

export const RemoveVehicleFinanceCompanyFieldHeader = styled.h4.attrs({
  id: 'RemoveVehicleFinanceCompanyFieldHeader',
})`
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 0.9rem;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeSpeed;
  margin-bottom: 8px;
  @media (max-width: 599px) {
  }
  @media (min-width: 600px) and (max-width: 959px) {
  }
  @media (min-width: 900px) and (max-width: 1279px) {
  }
  @media (min-width: 1280px) {
  }
`;
export const RequiredField = styled.span.attrs({})`
  color: red;
`;
export const RemoveVehicleFinanceCompanyButtonsContainer = styled.div.attrs({})`
  text-align: right;
  margin-right: 2%;
  margin-top: 10%;
  @media (max-width: 384px) {
    text-align: center;
  }
`;
export const RemoveVehicleFinanceCompanyButton = styled.button.attrs({})`
  margin-left: 10px;
  padding: 10px 20px;
  background-color: ${props => props.theme.primaryColor};
  color: white;
  :disabled {
    background-color: gray;
  }
  @media (max-width: 380px) {
    margin-bottom: 16px;
  }
`;

export const RemoveVehicleFinanceCompanyCancelButton = styled(
  RemoveVehicleFinanceCompanyButton,
).attrs({ id: 'Cancel' })``;
export const RemoveVehicleFinanceCompanySubmitButton = styled(
  RemoveVehicleFinanceCompanyButton,
).attrs({ id: 'Submit' })``;

export const RemoveVehicleFinanceCompanyComponent = styled.div.attrs({})`
  margin-bottom: 12px;
`;
export const RemoveVehicleFinanceCompanyRadioButton = styled.input.attrs({
  type: 'radio',
})`
  display: inline-block;
  vertical-align: top;
  margin-top: 2px;
  margin-left: 5px;
  margin-right: 5px;
  float: left;
`;
export const RadioLabel = styled.div.attrs({})`
  display: block;
  margin-left: 22px;
`;
export const RemoveVehicleFinanceCompanyTextAreaField = styled.textarea.attrs({
  id: 'removeVehicleFinanceCompanyTextAreaField',
})`
  height: 100px;
  margin-top: 5px;
  margin-bottom: 10px;
  width: 100%;
  @media (max-width: 599px) {
  }
  @media (min-width: 600px) and (max-width: 959px) {
  }
  @media (min-width: 900px) and (max-width: 1279px) {
  }
  @media (min-width: 1280px) {
  }
`;
